/*
 * @File
 * @Author Ngatia Frankline <fngatia@gmail.com>
 * @Created 1/18/23, 7:44 PM.
 * @Bincrud Copyright (c) 2023 All rights reserved.
 */

import '@popperjs/core'
import 'bootstrap'
import './bootstrap.scss'


console.log("Bootstrap library loaded...")
